import { callApi } from "../../utils/common.utils";

export const changePassword = async (
  userId: string,
  oldPassWord: string,
  newPassword: string
) => {
  const payLoad = {
    id: userId,
    oldpassword: oldPassWord,
    newpassword: newPassword,
  };
  return callApi("changedPassword", payLoad, "getData");
};
